import React, { useState, useEffect } from "react";
import { List, Button, Spin, Row, Col, Input, Select, Tag, Typography, Badge } from "antd";
import ChatComponent from "./ChatComponent";
import { getAll } from "../../servicios/solicitudes/servicios.ts";
import { auth } from "../../firebase";
import Title from "antd/es/typography/Title";

const BuscarSolicitud = () => {
  const { Option } = Select;
  const [solicitudes, setSolicitudes] = useState([]);
  const [filteredSolicitudes, setFilteredSolicitudes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedConversation, setSelectedConversation] = useState(null);

  const [searchId, setSearchId] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    const fetchConversations = async () => {
      setLoading(true);
      const validedToken = await auth.currentUser.getIdToken(true);
      const body = {
        sucursal: "Centro"
      }
      const response = await getAll(validedToken, body);
      if (response.success) {
        setSolicitudes(response.info);
        setFilteredSolicitudes(response.info);
      }
      setLoading(false);
    };

    fetchConversations();
  }, []);

  const filterSolicitudes = () => {
    let data = solicitudes;
    if (searchId) {
      data = data.filter(
        (solicitud) =>
          solicitud.folio.includes(searchId) ||
          solicitud.correo.includes(searchId)
      );
    }
    if (statusFilter) {
      data = data.filter((solicitud) => solicitud.status === statusFilter);
    }
    setFilteredSolicitudes(data);
  };

  useEffect(() => {
    filterSolicitudes();
  }, [searchId, statusFilter]);

  if (loading) {
    return <Spin tip="Cargando solicitudes..." />;
  }

  return (
    <div style={{ height: '80vh', background: '#f7f8fa', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px #f0f1f2' }}>
      <Row style={{ height: '100%' }} gutter={0}>
        <Col xs={24} md={10} lg={8} style={{ height: '100%', borderRight: '1px solid #eee', background: '#fff', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: 16, borderBottom: '1px solid #eee', background: '#fafbfc' }}>
            <Title level={4} style={{ margin: 0 }}>Solicitudes</Title>
            <Input
              placeholder="Buscar por folio o correo"
              value={searchId}
              onChange={(e) => setSearchId(e.target.value)}
              style={{ marginTop: 8 }}
              allowClear
            />
            <Select
              placeholder="Filtrar por estado"
              value={statusFilter}
              onChange={setStatusFilter}
              style={{ width: '100%', marginTop: 8 }}
              allowClear
            >
              <Option value="">Todos</Option>
              <Option value="Pendiente">Pendiente</Option>
              <Option value="Respondida">Respondida</Option>
              <Option value="Cerrado">Cerrado</Option>
            </Select>
          </div>
          <div style={{ flex: 1, overflowY: 'auto', background: '#fff' }}>
            <List
              itemLayout="horizontal"
              dataSource={filteredSolicitudes}
              renderItem={(item) => {
                const isSelected = selectedConversation && selectedConversation.folio === item.folio;
                let color = 'default';
                if (item.status === 'Activo') color = 'green';
                else if (item.status === 'Pendiente') color = 'orange';
                else if (item.status === 'Respondida') color = 'blue';
                else if (item.status === 'Cerrado') color = 'red';
                return (
                  <List.Item
                    style={{
                      background: isSelected ? '#e6f7ff' : '#fff',
                      borderLeft: isSelected ? '4px solid #1890ff' : '4px solid transparent',
                      cursor: 'pointer',
                      transition: 'background 0.2s',
                      paddingLeft: 12
                    }}
                    onClick={() => setSelectedConversation(item)}
                  >
                    <List.Item.Meta
                      title={<span><b>Folio:</b> {item.folio} <Tag color={color} style={{ marginLeft: 8 }}>{item.status}</Tag></span>}
                      description={<span><b>Correo:</b> {item.correo}</span>}
                    />
                  </List.Item>
                );
              }}
            />
          </div>
        </Col>
        <Col xs={24} md={14} lg={16} style={{ height: '100%', background: '#f7f8fa', display: 'flex', flexDirection: 'column' }}>
          {selectedConversation ? (
            <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <ChatComponent solicitudInfo={selectedConversation} />
            </div>
          ) : (
            <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa' }}>
              <Typography.Text strong>Selecciona una solicitud para ver los mensajes</Typography.Text>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BuscarSolicitud;
